import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { map, Subject } from 'rxjs';

import { PortalSalesAgentNode } from '@app/services/api/api.types';
import { AuthService, User } from '@app/services/auth/auth.service';
import { PopupsService } from '@voyagu/portal-design-system';
import { containerWidth } from '@app/utils/constants';
import { PortalTrackingEvents } from '@app/utils/tracking-events';
import { Tracking } from '@app/services/tracking/tracking.service';
import { CommonDataService } from '@app/services/common-data/common-data.service';
import { SignInModalService } from '@app/services/sign-in-modal.service';
import { AuthorizedDataService } from '@app/services/authorized-data/authorized-data.service';
import { Router } from '@angular/router';
import { PortalRoutes } from '@app/app-routing.module';
import { isEmbeddedInIframe } from '@app/utils/utils';
import { ReferralProgramService } from '@app/services/referral-program/referral-program.service';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  PortalRoutes = PortalRoutes;

  isEmbedded = isEmbeddedInIframe();

  @HostBinding('style.display') get hostDisplay() {
    return this.isEmbedded ? 'none' : null;
  }

  showedDetails: boolean;
  showedUser: boolean;

  user$: Subject<User | null>;

  @Input() salesAgent?: PortalSalesAgentNode;
  @Input() showLoginButton: boolean;
  @Input() showPhone = true;

  authService = inject(AuthService);
  signInModalService = inject(SignInModalService);
  popupsService = inject(PopupsService);
  commonDataService = inject(CommonDataService);
  authorizedDataService = inject(AuthorizedDataService);
  referralProgramService = inject(ReferralProgramService);
  router = inject(Router);

  referralProgram$ = this.referralProgramService
    .getState()
    .pipe(map((state) => (state.status === 'ready' ? state.data : null)));

  ngOnInit() {
    this.user$ = this.authService.user$;
  }

  toggleDetails(detailsTemplate: TemplateRef<unknown>) {
    if (window.innerWidth < containerWidth) {
      this.popupsService.showModal(detailsTemplate);
    } else {
      this.showedDetails = !this.showedDetails;
    }
  }

  toggleUser(userTemplate: TemplateRef<unknown>) {
    if (window.innerWidth < containerWidth) {
      this.popupsService.showModal(userTemplate);
    } else {
      this.showedUser = !this.showedUser;
    }
  }

  signOut() {
    Tracking.track(PortalTrackingEvents.portalLogoutPressed);
    this.referralProgramService.reset();
    void this.authService.signOut();
  }

  showSignInModal() {
    Tracking.track(PortalTrackingEvents.portalSignInPressed);
    this.signInModalService.showModal(false);
  }

  goToTrips() {
    this.popupsService.hideLast();
    void this.router.navigate([PortalRoutes.Trips]);
  }

  goToTravelers() {
    this.popupsService.hideLast();
    void this.router.navigate([PortalRoutes.Travelers]);
  }

  goToReferrals() {
    this.popupsService.hideLast();
    this.showedUser = false;
    void this.router.navigate([PortalRoutes.Referrals]);
  }
}
